module.exports = __webpack_public_path__ + "img/vertical_4_2_9006.1d774196.png";